import { useProxyWatch, useTranslation } from "@fanfanlo";
import { Box, Grid2 } from "@mui/material";
import { ITriggerTimeoutData } from "./ITriggerTimeout.inft";


export function UI(data: ITriggerTimeoutData) {
    const { t } = useTranslation('droid-project-interface/triggers/time/timeout/content')
    const [timeout] = useProxyWatch(data, 'javaData.timeout', data.javaData.timeout)
    return(
        <>
            <Box sx={{ width: '100%' }}>
                <Box>
                    <b>{t('ITriggerTimeout.title')}</b>
                </Box>
                <Grid2 container sx={{ width: '100%' }}>
                    <Grid2 size="grow" container>
                        <Box>
                            <span>
                                {t('ITriggerTimeout.content_delay')}
                            </span>
                            <span>
                                <input
                                    id="trigger-timeout-value-input"
                                    data-id="trigger-timeout-value-input"
                                    type="number" value={timeout} onChange={(e)=>data.javaData.timeout = Number(e.target.value)} />
                            </span>
                            <span>
                                {t('ITriggerTimeout.content_milliseconds')}
                            </span>
                        </Box>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    )
}
